import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedComponentsModule } from '../shared/shared.module';
import { Page1Component } from './page1.component';

const routes: Routes = [
  { path: '', component: Page1Component }
];

@NgModule({
  declarations:  [
    Page1Component
  ],
  imports: [
    SharedComponentsModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class Page1ComponentModule { }
